<template>
  <div class="fb fb-col height-full relative">
    <div>
      <md-searchbar
        v-model="keyword"
        v-if="type !== 'classGuardian'"
      ></md-searchbar>
      <div
        class="h-44 p-0-16 font-32 fb fb-main-start fb-cross-center address-nav"
      >
        <div
          v-for="(item, index) in history"
          :key="index"
          @click="back(item, index)"
          class="inline-block"
          :class="index === 0 ? '' : 'ml-4'"
        >
          <span
            :class="{
              'c-006AFE': index < history.length - 1,
              'c-171A1D-60': index === history.length - 1
            }"
            >{{ item.deptName || item.name }}</span
          >
          <i
            class="iconfont font-28 c-171A1D-40 ml-4"
            v-if="index < history.length - 1"
            >&#xe68d;</i
          >
        </div>
      </div>
    </div>
    <div v-if="list.length" class="item-flex-1 scroll-y pb-130">
      <div
        class="font-34 ff-regular bg-FFFFFF pl-16"
        v-for="(item, index) in list"
        :key="index"
      >
        <div
          class="fb fb-main-between fb-cross-center h-64"
          v-if="item.memberId"
        >
          <div class="pr-12 fb fb-main-between fb-cross-center">
            <div
              class="avatar mr-12 avator-image w-36 h-36"
              :class="item.imgClass"
              v-if="item.imgClass"
            ></div>
            <div
              v-else
              class="tree-name font-28 fb fb-main-center fb-cross-center c-FFFFFF w-36 h-36"
            >
              <span>{{ (item.name || item.memberName).slice(0, 2) }}</span>
            </div>
          </div>
          <div
            class="item-flex-1 fb fb-main-start fb-cross-center pr-16 height-full"
            :class="{
              'bb-111F2C-12': index < list.length - 1
            }"
            @click="form(item)"
          >
            <div class="item-flex-1">
              <div class="c-171A1D lh-24">{{
                filterName(item.name || item.memberName, 8)
              }}</div>
              <div class="font-28 c-171A1D-40 lh-20">{{
                item.deptName || item.relation
              }}</div>
            </div>
            <div class="w-84 pl-10 c-171A1D-40 fb fb-main-end fb-cross-center">
              <div
                class="mr-4"
                v-if="
                  !item.identityStatus &&
                  (!keyword ||
                    (keyword && type === 'classStudent') ||
                    type === 'student')
                "
                >待完善</div
              >
              <i class="iconfont">&#xe68d;</i>
            </div>
          </div>
        </div>
        <div
          v-else
          class="pr-8 h-56 fb fb-main-between fb-cross-center"
          :class="{
            'bb-111F2C-12': index < list.length - 1
          }"
        >
          <div class="item-flex-1">
            <span class="mr-8">{{
              filterName(item.deptName || item.memberName || item.name, 8)
            }}</span>
            <span
              :class="item.selStudentCnt ? 'c-006AFE' : 'c-171A1D-40'"
              v-if="!(type === 'classStudent' || type === 'classGuardian')"
              >({{ item.selStudentCnt }}/{{ item.studentCnt }})</span
            >
          </div>
          <div
            class="w-72 pl-10 c-006AFE bl-111F2C-24"
            @click="nextSeason(item)"
          >
            <i class="iconfont">&#xe714;</i>
            下级</div
          >
        </div>
      </div>
    </div>
    <div v-else class="relative item-flex-1">
      <common-no-data class="no-record w-fullVw h-258">
        <div class="no-course no-item"></div>
        <p class="font-28 c-171A1D-40">暂无记录</p>
      </common-no-data>
    </div>
    <div
      class="footer fb fb-col fb-main-around fb-cross-center"
      :class="{ 'h-125': isShowShareBtn }"
      @click="dingNotice"
      v-if="!keyword"
    >
      <md-button
        v-show="isShowShareBtn"
        @click="
          mixinRouter('/wechat/guideshare', {
            classId: $route.query.deptTpId || $route.query.tpId
          })
        "
        >通知家长关联微信号</md-button
      >
      <md-button>{{ noticeMsg }}</md-button>
    </div>
  </div>
</template>

<script>
import { deepCopy, filterName } from '@/utils/comUtils'
import API from '@/api'
import { LEAVE_ROLE, SANDBOX_TYPE } from '@/utils/constUtils'
import mixin from '@/mixin'
import {
  mcHidePreloader,
  mcShowPreloader,
  mcCreateMessage,
  mcSetTitle,
  mcToast
} from '@/utils/mcSdkUtils'
import { commonNoData } from '@/components'
export default {
  name: 'PageParentChild',
  mixins: [mixin],
  components: {
    commonNoData
  },
  data() {
    return {
      filterName,
      list: [],
      keyword: '',
      type: this.$route.params.type,
      sandboxId: '',
      isRegisterWx: false
    }
  },
  watch: {
    async keyword(newValue, oldValue) {
      if (newValue) {
        if (this.type === 'guardian') {
          const res = await API.searchOrgMember({
            memberName: newValue,
            operUserRoleTypes: this.currentRole
          })
          if (res && res.result && res.result !== '0') {
            return false
          }
          this.list = res
        } else if (this.type === 'student') {
          const res = await API.attendanceGetStudentList({
            keyWord: newValue,
            pageNum: 1,
            pageSize: 30,
            campusId: this.campusId,
            orgId: this.orgId
          })
          if (res && res.result && res.result !== '0') {
            return false
          }
          let temp = res.tagStudentInfoList
          temp = res.tagStudentInfoList.reduce((_list, item) => {
            return _list.concat({
              memberId: item.studentDingId,
              memberName: item.studentName,
              identityStatus: !!item.cardNo,
              gender: item.sexType,
              deptName: item.className,
              userDingId: item.studentDingId,
              guardians: (item.guardians || []).map(v => v.memberId)
            })
          }, [])
          this.list = this.calculateStudentImage(temp)
        } else if (this.type === 'classStudent') {
          // 班主任搜索接口
          const res = await API.searchByName({
            campusId: this.campusId,
            liveInOnly: false,
            limit: 30,
            q: newValue,
            returnExtFields: ['className', 'gender', 'deptId', 'cardNo'],
            roleTypeList: [LEAVE_ROLE.headmaster]
          })
          if (res && res.result && res.result !== '0') {
            return false
          }
          let temp = []
          temp = res.reduce((_list, item) => {
            return _list.concat({
              memberId: item.studentDingId,
              memberName: item.studentName,
              identityStatus: !!item.cardNo, // 搜索接口没有返回cardNo
              gender: item.gender,
              deptName: item.className,
              userDingId: item.studentDingId,
              guardians: (item.guardians || []).map(v => v.memberId)
            })
          }, [])
          this.list = this.calculateStudentImage(temp)
        } else if (this.type === 'classGuardian') {
        }
      } else if (
        this.type === 'classStudent' ||
        this.type === 'classGuardian'
      ) {
        if (+this.$route.params.id) {
          if (this.type === 'classGuardian') {
            this.getClassGuardian(this.$route.params.id)
          } else {
            this.getClassStudent(this.$route.params.id)
          }
        } else {
          this.list = this.$store.getters.headmasterClass.find(
            item => item.tpId === this.campusId
          ).schoolClassDtoList
        }
      } else {
        this.ajaxPolling(this.sandboxId, +this.$route.params.id)
      }
    }
  },
  computed: {
    currentIndex() {
      let data = this.$store.getters.history || []
      let index = data.findIndex(item => item.id === +this.$route.params.id)
      return index === -1 ? 0 : index
    },
    history() {
      return this.$store.getters.history || []
    },
    noticeMsg() {
      if (this.type === 'student' || this.type === 'classStudent') {
        return '通知家长完善学生身份信息'
      } else {
        return '通知家长完善身份信息'
      }
    },
    isShowShareBtn() {
      const { deptTpId, tpId } = this.$route.query
      const index = this.classList.findIndex(
        item => item.tpId === (deptTpId || tpId)
      )
      return (
        index > -1 &&
        ['classGuardian', 'guardian'].includes(this.type) &&
        this.isRegisterWx
      )
    }
  },
  created() {
    if (this.type === 'student' || this.type === 'classStudent') {
      mcSetTitle('学生信息管理')
    } else {
      mcSetTitle('家长信息管理')
    }
    if (this.type === 'classStudent' || this.type === 'classGuardian') {
      const classList = this.$store.getters.headmasterClass.find(
        item => item.tpId === this.campusId
      ).schoolClassDtoList
      // 单独判断：如果班主任只有一个班，直接显示学生
      if (+this.$route.params.id) {
        if (this.type === 'classGuardian') {
          this.getClassGuardian(this.$route.params.id)
        } else {
          this.getClassStudent(this.$route.params.id)
        }
      } else {
        this.list = classList
        this.$nextTick(() => {
          if (classList.length === 1) {
            this.nextSeason(classList[0])
          }
        })
      }
    } else {
      if (this.type === 'student') {
        this.sandboxId = this.$store.getters.studentSandBoxId
      } else {
        this.sandboxId = this.$store.getters.guardianSandBoxId
      }
      mcShowPreloader({ text: '初始化···' })
      if (this.sandboxId) {
        this.ajaxPolling(this.sandboxId, +this.$route.params.id)
      } else {
        this.createSandBox()
      }
    }

    let history = this.$store.getters.history || []
    let data = []
    for (let index = 0; index < history.length; index++) {
      const element = history[index]
      data.push(element)
      if (element.id === +this.$route.params.id) {
        break
      }
    }
    this.$nextTick(() => {
      this.$store.commit('setHistory', data)
    })
    if (['classGuardian', 'guardian'].includes(this.type)) {
      this.judgeRefister()
    }
  },
  methods: {
    // 发送ding通知
    dingNotice() {
      let deptIds = []
      if (this.keyword) {
        deptIds = this.list.map(item => item.memberId)
      } else if (
        this.type === 'classStudent' ||
        this.type === 'classGuardian'
      ) {
        if (+this.$route.params.id === 0) {
          deptIds = this.list.map(item => item.tpId)
        } else {
          deptIds = [this.$route.params.id]
        }
      } else {
        deptIds = [
          +this.$route.params.id === 0
            ? this.list[0].deptTpId
            : this.$route.params.id
        ]
      }
      mcShowPreloader({ text: '加载中' })
      // deptTpId ---> deptId
      API.getUserNoticeList({
        sandboxId: this.sandboxId,
        campusId: this.campusId,
        deptIds,
        operUserRoleTypes: this.$store.getters.currentRole, // 当前角色
        userType:
          this.type === 'classStudent' || this.type === 'student' ? 3 : 2
      })
        .then(res => {
          mcHidePreloader()
          if (res && res.result && res.result !== '0') {
            mcToast({ msg: res.message })
            return false
          }
          mcCreateMessage({
            users: res,
            corpId: this.corpId,
            text: `请${this.corpName}的家长完善个人及学生身份信息。`,
            attachment: {
              title: '录入个人身份信息',
              url: `${this.h5Host}/?corpId=${this.corpId}#/?redircetHash=%2FentryInformation%2Fguardian%2Findex&currentRole=1&role=1`,
              image: `${this.h5Host}/static/img/ding-notice.png`,
              text: '一键录入，简单高效'
            }
          })
        })
        .catch(() => {
          mcHidePreloader()
        })
    },
    createSandBox() {
      API.createUserSandBox({
        campusId: (this.$store.getters.currentCapmus || {}).tpId || '', // 校区ID
        operUserRoleType: this.$store.getters.currentRole, // 当前角色
        sandboxType: SANDBOX_TYPE[this.type]
      })
        .then(res => {
          if (res && res.result && res.result !== '0') {
            mcHidePreloader()
            mcToast({ msg: res.message })
            return false
          }
          this.ajaxPolling(res)
        })
        .catch(() => {
          mcHidePreloader()
        })
    },
    ajaxPolling(sandboxId, deptTpId) {
      if (this.isDestroyed) {
        mcHidePreloader()
        return
      }
      API.sandBoxStatus({
        calcStudentSelCnt: true,
        sandboxId
      })
        .then(res => {
          if (res && res.result && res.result !== '0') {
            mcHidePreloader()
            return false
          }
          if (res.sandboxStatus === 2) {
            mcHidePreloader()
            // 沙盒已准备好，保存一下沙盒ID
            this.$store.commit(
              this.type === 'student'
                ? 'setStudentSandBoxId'
                : 'setGuardianSandBoxId',
              sandboxId
            )
            this.sandboxId = sandboxId
            if (
              +this.$route.query.type === 3 &&
              this.$route.query.hasChildren === 'false'
            ) {
              if (this.type === 'guardian') {
                this.getClassGuardian(deptTpId)
              } else {
                this.getClassStudent(deptTpId)
              }
            } else {
              this.getSubNodes(sandboxId, deptTpId)
            }
          } else {
            setTimeout(() => {
              this.ajaxPolling(sandboxId)
            }, 1500)
          }
        })
        .catch(() => {
          mcHidePreloader()
        })
    },
    getClassGuardian(deptTpId) {
      API.getClassGuardian({
        classId: deptTpId,
        campusId: this.campusId
      })
        .then(res => {
          if (res && res.result && res.result !== '0') {
            return false
          }
          this.list = res
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    },
    getClassStudent(deptTpId) {
      API.getClassStudent({
        classId: deptTpId,
        campusId: this.campusId
      })
        .then(res => {
          if (res && res.result && res.result !== '0') {
            return false
          }
          res.map(item => {
            item.gender = item.sex
          })
          this.list = this.calculateStudentImage(res)
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    },
    getSubNodes(sandboxId, deptTpId) {
      API.sandBoxSubNodes({
        parentDeptId: deptTpId || null,
        sandboxId
      })
        .then(res => {
          if (res && res.result && res.result !== '0') {
            return false
          }
          if (!deptTpId) {
            this.nextSeason(res[0])
            return
          }
          this.list = res
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    },
    nextSeason(item) {
      let history = deepCopy(this.$store.getters.history || [])
      history.push(item)
      this.$store.commit('setHistory', history)
      // item.deptTpId
      if (this.type === 'classStudent' || this.type === 'classGuardian') {
        this.$router.replace({
          path: `/entryInformation/homeSchool/${this.type}/${item.tpId}`,
          query: item
        })
      } else {
        this.$router.replace({
          path: `/entryInformation/homeSchool/${this.type}/${item.deptTpId}`,
          query: item
        })
      }
    },
    back(item, index) {
      let history = this.$store.getters.history || []
      let data = []
      for (let index = 0; index < history.length; index++) {
        const element = history[index]
        data.push(element)
        if (this.type === 'classStudent' || this.type === 'classGuardian') {
          if (element.tpId === item.tpId) {
            break
          }
        } else {
          if (element.deptTpId === item.deptTpId) {
            break
          }
        }
      }
      this.$nextTick(() => {
        this.$store.commit('setHistory', data)
      })
      if (this.type === 'classStudent' || this.type === 'classGuardian') {
        this.$router.replace({
          path: `/entryInformation/homeSchool/${this.type}/${item.tpId || 0}`,
          query: item
        })
      } else {
        this.$router.replace({
          path: `/entryInformation/homeSchool/${this.type}/${
            item.deptTpId || 0
          }`,
          query: item
        })
      }
    },
    form(item) {
      this.$router.push({
        path: '/entryInformation/form',
        query: {
          imgClass: item.imgClass || '',
          memberId: item.memberId,
          studentId: item.userDingId || '',
          userType: item.imgClass ? 3 : 2,
          campusId: this.campusId,
          sandboxId: this.sandboxId,
          deptTpId: this.$route.query.deptTpId || this.$route.query.tpId
        }
      })
    },
    judgeRefister() {
      API.judgeRefister()
        .then(res => {
          if (res && res.result && res.result !== '0') {
            return false
          }
          this.isRegisterWx = res
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.bl-111F2C-24 {
  border-left: 1px solid rgba(17, 31, 44, 0.24);
}
.bb-111F2C-12 {
  border-bottom: 1px solid rgba(17, 31, 44, 0.12);
}
.tree-name {
  background: #006afe;
  border-radius: 50%;
}
.no-record {
  .no-course {
    width: 180px;
    height: 180px;
    &.no-item {
      background: url(~@/assets/images/no-data.png) no-repeat center top;
      background-size: 180px 180px;
    }
  }
}
.address-nav {
  overflow-y: hidden;
  overflow-x: scroll;
  & > div {
    flex-shrink: 0;
  }
}
</style>
